import { useState } from "react";
import { Cute } from "../../../assets/contact";
import { toast } from "react-toastify";
import axios from "axios";
const Base_Url = process.env.REACT_APP_BASE_URL;
export default function SectionThree() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(`${Base_Url}/api/enquiry/createEnquiry`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
      );

      if (res.data.success) {
        toast.success(res.data.message || "Your query submitted successfully");
      }
      setFormData({ name: "", email: "", mobileNumber: "", message: "" });
    } catch (err) 
    {
      console.error(err);
      toast.error(err.response?.data?.message || "Something went wrong");
    }  
  };

  return (
    <section className="py-5 md:py-8 px-4 md:px-8 xl:px-10 grid grid-cols-1 md:grid-cols-2 gap-5">
    <div className="order-2 md:order-1 flex items-center justify-center">
        <img src={Cute} className="h-60 md:h-96"/>
    </div>
    <div className="order-1 md:order-2">
      <h2 className="text-xl md:text-2xl font-bold text-center mb-6 text-[#A63F40]">Get In Touch</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Name"
          className="w-full border border-gray-400 rounded px-3 py-2 focus:outline-none"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          className="w-full border border-gray-400 rounded px-3 py-2 focus:outline-none"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="mobileNumber"
          placeholder="Mobile Number"
          className="w-full border border-gray-400 rounded px-3 py-2 focus:outline-none"
          value={formData.mobileNumber}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Message"
          rows={4}
          className="w-full border border-gray-400 rounded px-3 py-2 focus:outline-none"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button
          type="submit"
          className="w-full bg-[#A63F40] text-white font-medium py-2 rounded hover:bg-[#722628] transition"
        >
          Send Message
        </button>
      </form>
    </div>
    </section>
  );
}
